/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  $(".mute-video").click( function (){
    if( $(this).closest('.hero__video').find('video').prop('muted') ) {
      $(this).closest('.hero__video').find('video').prop('muted', false);
    } else {
      $(this).closest('.hero__video').find('video').prop('muted', true);
    }

    if ($(this).hasClass('active') ) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');    
    }
    
  });

  var position = $(window).scrollTop(); 
  $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if(scroll > 1) {
          $('.custom-shed-trailers-navigation').addClass('stick');
      } else {
         $('.custom-shed-trailers-navigation').removeClass('stick');
      }
      position = scroll;
  });

  $(document).ready(function(){
    // Select all links with hashes
    $('.nav-page-custom a.navlink[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - $('#header-main').height() - 70
          }, 300, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



// slick slide

var helpers = {
  addZeros: function (n) {
    return (n < 10) ? '0' + n : '' + n;
  }
};

function sliderInit() {
  var $slider = $('.slider-holder');
  $slider.each(function() {
    var $sliderParent = $(this).parent();
    $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
       speed: 500,
      fade: true,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            adaptiveHeight: true
          }
        }
      ]
    });

    if ($(this).find('.item').length > 1) {
      $(this).siblings('.slides-numbers').show();
    }

    $(this).on('afterChange', function(event, slick, currentSlide){
      $sliderParent.find('.slides-numbers .active').html(helpers.addZeros(currentSlide + 1));
    });

    var sliderItemsNum = $(this).find('.slick-slide').not('.slick-cloned').length;
    $sliderParent.find('.slides-numbers .total').html(helpers.addZeros(sliderItemsNum));

  });
  
//   $('.slick-next').on('click', function () {
//     console.log('test');
//     $('.slider-holder').slick('slickGoTo', 5);
// });


  
};

sliderInit();


$('.btn-contactPopup').on('click', function(){
    $('#transax-widget .round-button').trigger('click');
});



var position = $(window).scrollTop(); 
var topBanHeight = $('.announcement__wrapper--top').outerHeight(); //Anomation bar

$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if(scroll > topBanHeight) {
        $('.nav-page-custom').addClass('stick');
    } else {
       $('.nav-page-custom').removeClass('stick');
    }
    position = scroll;
});






$(document).ready(function(){



  
  $('.image-popup-vertical-fit').magnificPopup({
  	type: 'image',
    mainClass: 'mfp-with-zoom', 
    fixedContentPos: true,
    fixedBgPos: true,
    overflowY: 'hidden',
    closeOnBgClick: true,
    gallery:{
  			enabled:true
  		},
  
    zoom: {
      enabled: true, 
      duration:300, // duration of the effect, in milliseconds
      //easing: 'ease-in-out', // CSS transition easing function
  
      opener: function(openerElement) {
        return openerElement.is('img') ? openerElement : openerElement.find('img');
    }
  }
  
  });

});


